import {
    ApplicationRef,
    ComponentFactoryResolver,
    EmbeddedViewRef,
    Injectable,
    Injector
} from "@angular/core";
import {kanLoading} from "../components/loading/component";

@Injectable()
export class kanLoadingService {

    public element: HTMLElement;
    private count = 0;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private appRef: ApplicationRef,
                private injector: Injector) {
    }

    public show() {

        if(this.count) {
            this.count++;
        } else {
            this.count++;
            let componentRef = this.componentFactoryResolver
                .resolveComponentFactory(kanLoading)
                .create(this.injector);

            this.appRef.attachView(componentRef.hostView);

            this.element = (componentRef.hostView as EmbeddedViewRef<any>)
                .rootNodes[0] as HTMLElement;

            document.body.appendChild(this.element);
        }
    }

    public hide() {
        if (this.element && this.count <= 1) {
            this.element.remove();
            this.element = null;
            this.count = 0;
        } else {
            this.count--;
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/loading.ts